import { render, staticRenderFns } from "./CourseListItemTables.vue?vue&type=template&id=1a25de70&"
import script from "./CourseListItemTables.vue?vue&type=script&lang=ts&"
export * from "./CourseListItemTables.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports